<template>
  <div :class="$style.wrapper" :key="key">
    <BackToHub />
    <HelloPopup v-if="stage === 0" @click="() => { stage++ }">
      <h1>Привет, друг!</h1>
      <p>
        Твой робот участвует в интеллектуальной битве роботов. Разгадай последовательность и сделай свой ход. За выбранную с первого раза правильную карточку дают +2 балла, со второй попытки + 1 балл. Присмотрись, это не просто баллы, а способность твоего робота отражать атаку противника.
      </p>
    </HelloPopup>
    <SuccessPopup
      v-if="stage === 2"
      :score="score"
      :max="ROBOT.maxPoints"
      :achievement="ROBOT.achievement"
      text="А ты молодец! Хорошо справился, хотя задание было не из простых."
      @click="() => { stage++ }"
    />
    <VideoPopup
      v-if="stage === 3"
      @click="() => this.$userStory.next({ result: score })"
      :video="'https://player.vimeo.com/video/370902895'"
    />

    <HeaderWithCounter
      :score="score"
      :items="proxyItems"
    />
    <div :class="$style.oldCards">
      <Card
        v-for="card in currentSet.old"
        :key="card.id * (currentSetIndex + 1)"
        :face="card.image"
        :up="card.up"
        :animation="true"
        @click="() => { card.up = true }"
      />
      <div :class="classes($style.card, $style.place, 'drop-zone')" data-cardzone="true" ref="dropzone"></div>
    </div>
    <div :class="$style.newCards">
      <div
        v-for="card in currentSet.new"
        :key="card.id * (currentSetIndex + 1)"
        :class="[$style.newCardWrapper, 'drop-zone']"
        :data-zone="card.id"
      >
        <Card
          :class="`card-draggable ${$style.newCard}`"
          :face="card.image"
          :up="true"
          :animation="false"
          :data-zone="card.id"
          :data-correct="card.correct"
        />
      </div>
    </div>
    <Robo
      ref="left"
      :position="'left'"
      :title="'Ура! Я победил!'"
      :text="`Ты угадал верный набор карт и заработал \n${pointsString}, так держать!`"
      @stop="() => { this.runResult(true) }"
      :winAnimation="animations.left.win"
      :failAnimation="animations.left.fail"
    />
    <Robo
      ref="right"
      :position="'right'"
      :title="'Поражение!'"
      :text="'Ты не угадал последовательность карт \nи проиграл эту битву!'"
      @stop="closeFailure"
      :level="currentSetIndex + 1"
      :winAnimation="animations.right[currentSetIndex + 1].win"
      :failAnimation="animations.right[currentSetIndex + 1].fail"
    />
  </div>
</template>
<script>
import classes from '@/utils/classes'
import plural from '@/utils/plural'
import cards from './items'

import HeaderWithCounter from '@/components/HeaderWithCounter/HeaderWithCounter.vue'
import SuccessPopup from '@/components/SuccessPopup/SuccessPopup.vue'
import VideoPopup from '@/components/VideoPopup/VideoPopup.vue'
import HelloPopup from '@/components/HelloPopup/HelloPopup.vue'
import BackToHub from '@/components/BackToHub/BackToHub.vue'
import Card from './components/Card/Card.vue'
import Robo from './components/Robo/Robo.vue'

import animations from './animations'

import { ROBOT } from '@/services/UserStory'

import routerCheck from '@/mixins/routerCheck'

export default {
  name: 'Lesson2',
  components: {
    HeaderWithCounter, Card, Robo, SuccessPopup, HelloPopup, VideoPopup, BackToHub,
  },
  mixins: [routerCheck],
  data: () => ({
    score: 0,
    stage: 0,
    points: 2,
    currentSetIndex: 0,
    proxyItems: [],
    key: 0,
    cards,
    ROBOT,
  }),
  mounted() {
    this.initDraggable()
  },
  watch: {
    stage(stage) {
      if (stage === 1) {
        this.$userStory.start()
      }
    },
  },
  methods: {
    initDraggable() {
      const { Droppable } = require('@shopify/draggable')
      const container = this.$el
      this.draggable = new Droppable(container, {
        draggable: '.card-draggable',
        dropzone: '.drop-zone',
        mirror: {
          constrainDimensions: true,
          appendTo: 'body',
        },
      })

      this.droppableOrigin = null
      this.droppable = null

      this.draggable.on('drag:start', (evt) => {
        this.droppableOrigin = evt.data.source.dataset.zone
        this.droppable = evt.data.source
      })

      this.draggable.on('droppable:dropped', (evt) => {
        if (this.droppableOrigin !== evt.dropzone.dataset.zone && evt.dropzone.dataset.zone !== undefined) {
          evt.cancel()
        }
      })

      this.draggable.on('drag:stop', () => {
        const { lastDropzone } = this.draggable
        if (lastDropzone && lastDropzone.dataset.cardzone === 'true') {
          const isCorrect = !!this.droppable.dataset.correct
          if (isCorrect) {
            this.runSuccess()
          } else {
            this.runFailure()
          }
        }
      })
    },
    destroyDraggable() {
      this.draggable.destroy()
      this.$refs.dropzone.querySelector('div').remove()
      this.$refs.dropzone.classList.remove('draggable-dropzone--occupied')
    },
    runSuccess() {
      this.$refs.right.run(false)
      this.$refs.left.run(true)
      this.score += this.points

      this.proxyItems[this.currentSetIndex].found = true
      this.proxyItems[this.currentSetIndex].imageFound = require('./assets/foundImage.png')

      this.$set(this, 'proxyItems', this.proxyItems)
    },
    runFailure() {
      this.$refs.right.run(true)
      this.$refs.left.run(false)
      this.points = Math.max(0, this.points - 1)
      // this.score += this.points

      // this.proxyItems[this.currentSetIndex].found = true
      // this.proxyItems[this.currentSetIndex].imageFound = require('./assets/imageNotFound.svg')

      // this.$set(this, 'proxyItems', this.proxyItems)
      // this.points = Math.min(0, this.points - 1)
    },
    closeFailure() {
      const dropzone = document.querySelector('.drop-zone')
      const card = dropzone.querySelector('.card-draggable')
      dropzone.classList.remove('draggable-dropzone--occupied')
      card.remove()
    },
    reInitDraggable() {
      this.key += 1
      this.destroyDraggable()
      this.$nextTick().then(() => {
        this.initDraggable()
      })
    },
    runResult() {
      if (this.currentSetIndex === cards.length - 1) {
        this.stage = 2
        return
      }
      this.points = 2
      this.currentSetIndex += 1
      this.reInitDraggable()
    },
  },
  computed: {
    pointsString() {
      const { points } = this
      return `${points} ${plural(points, 'балл', 'балла', 'баллов')}`
    },
    currentSet() {
      return cards[this.currentSetIndex]
    },
  },
  created() {
    this.classes = classes
    this.animations = animations
    this.proxyItems = this.cards.map(() => ({
      found: false,
      imageFound: '',
    }))
  },
}
</script>
<style lang="scss" module>
@import './Lesson2.scss';
</style>
